import styled from 'styled-components';

export const Line = styled.div`
  min-height: 4px;
  width: 74px;
  background-color: ${({ theme }) => theme.colors.korall};
  margin-top: -4px;
`;
